import { Component, Input, OnInit } from '@angular/core';
import { UscModalComponent } from '../../usc-store/usc-modal/usc-modal.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { DialogService, ModalService, SessionService } from '../../../services';
import { UscStoreService } from '../../../services/usc-store/usc-store.service';
import { DialogComponent } from '../../common/dialog/dialog.component';
import { UscDialogComponent } from '../../usc-store/usc-dialog/usc-dialog.component';
import { ReplaySubject } from 'rxjs';

@Component({
    selector: 'sn-usc-svt-checkin',
    templateUrl: './usc-svt-checkin.component.html',
    styleUrls: ['./usc-svt-checkin.component.css']
})
export class UscSvtCheckinComponent implements OnInit {
    @Input() view: string;

    constructor(
        public uscStoreService: UscStoreService,
        public ngbModal: NgbModal,
        public modalService: ModalService,
        public dialogService: DialogService,
        public sessionService: SessionService,        
    ) { }

    public confirmation_number:number;
    error_code_schedule_appointment_not_found: number = -1003;
    error_code_appointment_already_checked_in: number = -1004;
    error_code_checked_in_time_limit_failed: number = -1005;


    ngOnInit() {
        this.delatedCheckInItemID.subscribe(item_ID => { 
            var dlg = this.dialogService.showLoadingDlg(DialogComponent, {msg: "Checking In Customer..." });
            this.uscStoreService.processActionOnViewItem(this.uscStoreService.view_store_visit_checkin, item_ID, this.uscStoreService.action_svt_checkin_customer, null).subscribe(
                result => {
                    dlg.dismiss();
                }, error => {
                    dlg.dismiss();
                }
            )
        })

        this.delatedStartServingItemID.subscribe(item_ID => { 
            var dlg = this.dialogService.showLoadingDlg(DialogComponent, {msg: "Start Serving Customer..." });
            this.uscStoreService.processActionOnViewItem(this.uscStoreService.view_store_visit_checkin, item_ID, this.uscStoreService.action_svt_start_serving, null).subscribe(
                result => {
                    dlg.dismiss();
                    this.uscStoreService.setCurrentView(this.uscStoreService.view_store_visit_serving_now);
                }, error => {
                    dlg.dismiss();
                }
            )
        })
    }

    processCheckInBillPayment(event) {
        this.openForm(this.uscStoreService.form_svt_bill_payment);
    }

    processCheckInSalesAssociate(event) {
        this.openForm(this.uscStoreService.form_svt_sales_associate);
    }

    processCheckInAppointment(event) {
        const modalRef = this.ngbModal.open(UscDialogComponent, { backdrop: 'static', keyboard: false });
        modalRef.componentInstance.parentView = this.uscStoreService.view_store_visit_scheduled_appt;
        modalRef.componentInstance.dlgType = this.uscStoreService.dialog_type_svt_appointment_check_in;
        modalRef.result.then((result) => {
            if (result.response != 'cancel') {
                var dlg = this.dialogService.showLoadingDlg(DialogComponent, {msg: "Checking In Customer..." });
                var param = { me_ID: result.confirmation_number };
                this.uscStoreService.processActionOnViewItem(this.uscStoreService.view_store_visit_scheduled_appt, 0, this.uscStoreService.action_svt_checkin_customer, param).subscribe(
                    result => {
                        dlg.dismiss();
                        if (result && result.errors) {
                            var appt_not_found = result.errors.find(e => e.error_code == this.error_code_schedule_appointment_not_found);
                            var appt_checked_in = result.errors.find(e => e.error_code == this.error_code_appointment_already_checked_in);
                            var time_limit_failed = result.errors.find(e => e.error_code == this.error_code_checked_in_time_limit_failed);

                            var error_msg = "";
                            if (appt_not_found) error_msg = "Check-in was unsuccessful.  Scheduled appointment not found.";
                            if (appt_checked_in) error_msg = "Check-in was unsuccessful.  This appointment has already been checked-in.";
                            if (time_limit_failed) error_msg = "Check-in was unsuccessful.  Please check-in within 30 minutes of your appointment time.";
                            var modalRef = this.dialogService.showDialog(DialogComponent, this.dialogService.dlg_type_confirmation, {msgList: [error_msg]});
                        }                  
                    }, error => {
                        this.sessionService.log('sn_view_action::' + this.uscStoreService.action_svt_checkin_customer + ' failed');
                        dlg.dismiss();
                    }
                )
            }
        });
    }

    private delatedCheckInItemIDSubject = new ReplaySubject<any>(1);
    public delatedCheckInItemID = this.delatedCheckInItemIDSubject.asObservable();
    private delatedStartServingItemIDSubject = new ReplaySubject<any>(1);
    public delatedStartServingItemID = this.delatedStartServingItemIDSubject.asObservable();

    openForm(view) {
        const modalRef = this.ngbModal.open(UscModalComponent, { backdrop: 'static', keyboard: false });
        let item = { dl_ID: 0, co_work_phone1: null, co_firstname: null, co_lastname: null, me_notes: null };
        modalRef.componentInstance.view = view;
        modalRef.componentInstance.data = item;
        modalRef.result.then((result) => {
            this.sessionService.log(`${view} created`);
            var view_item_ID = result.data.find(f => f.key == 'dl_ID').value;
            switch (result.event) {
                case "save_bill_payment":
                case "save_sales_associate":
                    this.delatedCheckInItemIDSubject.next(view_item_ID);
                    break;
                case "save_and_start_bill_payment":
                case "save_and_start_sales_associate":
                    this.delatedStartServingItemIDSubject.next(view_item_ID);
                    break;
            }
        });
    }
}



// WEBPACK FOOTER //
// C:/Azure/Source/Workspaces/SalesNOW/SalesSOLO/WebSites/SalesSOLO.Web.Angular.telesales/src/app/components/usc-store-scheduling/usc-svt-checkin/usc-svt-checkin.component.ts